import template from './myVacations.html';
import controller from './myVacations.controller';
import './myVacations.scss';

let myVacationsComponent = {
  restrict: 'E',
  bindings: {
    userInceptionId: '<',
    isWageInProcess: '<'
  },
  template,
  controller
};

export default myVacationsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/myVacations.component.js